import { CLOUDINARY_CLOUD_NAME } from './constants';

const UPLOAD_WIDGET_CONFIG = {
  cloudName: CLOUDINARY_CLOUD_NAME,
  sources: ['local'],
  showAdvancedOptions: false,
  cropping: false,
  multiple: false,
  defaultSource: 'local',
  styles: {
    // Default styles
    palette: {
      window: '#FFFFFF',
      windowBorder: '#90A0B3',
      tabIcon: '#0078FF',
      menuIcons: '#5A616A',
      textDark: '#000000',
      textLight: '#FFFFFF',
      link: '#0078FF',
      action: '#FF620C',
      inactiveTabIcon: '#0E2F5A',
      error: '#F44235',
      inProgress: '#0078FF',
      complete: '#20B832',
      sourceBg: '#E4EBF1',
    },
    fonts: {
      default: {
        active: true,
      },
    },
  },
};

export default UPLOAD_WIDGET_CONFIG;
